var map = {
	"./ErrorPages/404.vue": [
		"898f",
		"chunk-2d0df2e5"
	],
	"./Index/floor1.vue": [
		"c66e",
		"chunk-5948f2e5"
	],
	"./Index/floor2.vue": [
		"258e",
		"chunk-5d5a6b87"
	],
	"./Index/floor3_new.vue": [
		"5bf5",
		"chunk-07efb115"
	],
	"./Index/floor5.vue": [
		"a07d",
		"chunk-3bb5c006"
	],
	"./Index/floor6.vue": [
		"fd4c",
		"chunk-e6cff0c8"
	],
	"./Index/homePage.vue": [
		"52a8",
		"chunk-b94e4516",
		"chunk-8121eaa6"
	],
	"./Index/homePage/AiModelSection.vue": [
		"cf9c",
		"chunk-37f98d37"
	],
	"./Index/homePage/CertificationSection.vue": [
		"778e",
		"chunk-098b55b6"
	],
	"./Index/homePage/CloudCard.vue": [
		"f314",
		"chunk-182a6260"
	],
	"./Index/homePage/CloudSection.vue": [
		"903a",
		"chunk-86e4b806"
	],
	"./Index/homePage/HeroSection.vue": [
		"65d63",
		"chunk-1a69793d"
	],
	"./Index/homePage/PlatformSection.vue": [
		"6c13",
		"chunk-b94e4516"
	],
	"./Index/homePage/RobotSection.vue": [
		"e849",
		"chunk-520d87ad"
	],
	"./Index/index.vue": [
		"fbaf",
		"chunk-069da51a"
	],
	"./about/index.vue": [
		"81b2",
		"chunk-443111da",
		"chunk-73a4595c",
		"chunk-483df497"
	],
	"./business/ai.vue": [
		"3dfa",
		"chunk-443111da",
		"chunk-73a4595c",
		"chunk-4acceddd"
	],
	"./business/cloud.vue": [
		"e44f",
		"chunk-443111da",
		"chunk-73a4595c",
		"chunk-0f48246d"
	],
	"./business/robot.vue": [
		"d9bd",
		"chunk-443111da",
		"chunk-73a4595c",
		"chunk-692eeb69"
	],
	"./coPlan/PartnerContent.vue": [
		"e4de",
		"chunk-e0bcd74e",
		"chunk-6c137696"
	],
	"./coPlan/coPlan.vue": [
		"e8aa",
		"chunk-443111da",
		"chunk-73a4595c",
		"chunk-e0bcd74e",
		"chunk-71cfa054"
	],
	"./home/index.vue": [
		"f5b8",
		"chunk-443111da",
		"chunk-73a4595c",
		"chunk-7cb5c91a"
	],
	"./leapoAI/LeapoAiContent.vue": [
		"da35",
		"chunk-629a29d0",
		"chunk-6c137696"
	],
	"./leapoAI/leapoAI.vue": [
		"20b7",
		"chunk-443111da",
		"chunk-73a4595c",
		"chunk-629a29d0",
		"chunk-23d4b3b4"
	],
	"./market/AiMarketingContent.vue": [
		"4af6",
		"chunk-18e1b3d4",
		"chunk-6c137696"
	],
	"./market/market.vue": [
		"10e2",
		"chunk-443111da",
		"chunk-73a4595c",
		"chunk-18e1b3d4",
		"chunk-44c6e54a"
	],
	"./news/detail.vue": [
		"4afa",
		"chunk-443111da",
		"chunk-73a4595c",
		"chunk-4833e4e6"
	],
	"./news/index.vue": [
		"9768",
		"chunk-443111da",
		"chunk-73a4595c",
		"chunk-920e5832"
	],
	"./nineToken/JiuciContent.vue": [
		"c780",
		"chunk-7d415c72"
	],
	"./nineToken/nineToken.vue": [
		"2802",
		"chunk-443111da",
		"chunk-73a4595c",
		"chunk-0abf2ffc"
	],
	"./product/ai/ai-server.vue": [
		"0a5e",
		"chunk-443111da",
		"chunk-73a4595c",
		"chunk-72501bba"
	],
	"./product/ai/analysis.vue": [
		"c26a",
		"chunk-443111da",
		"chunk-73a4595c",
		"chunk-3b97993d"
	],
	"./product/ai/call.vue": [
		"3d80",
		"chunk-443111da",
		"chunk-73a4595c",
		"chunk-671c47ce"
	],
	"./product/ai/creation.vue": [
		"a33a",
		"chunk-443111da",
		"chunk-73a4595c",
		"chunk-01726cbd"
	],
	"./product/ai/data-service.vue": [
		"d0b3",
		"chunk-443111da",
		"chunk-73a4595c",
		"chunk-3dffe482"
	],
	"./product/aiShopkeeper.vue": [
		"011e",
		"chunk-443111da",
		"chunk-73a4595c",
		"chunk-079e323c",
		"chunk-66b8fc1a"
	],
	"./product/components/cardItem.vue": [
		"5587",
		"chunk-f862f1aa"
	],
	"./product/components/dsUpModule.vue": [
		"139d",
		"chunk-826a438e"
	],
	"./product/components/moduleBgBlue.vue": [
		"a8b8",
		"chunk-38d7e389"
	],
	"./product/components/moduleCenter.vue": [
		"c104",
		"chunk-720cb74d"
	],
	"./product/components/moduleTitle.vue": [
		"9582",
		"chunk-03f7703f"
	],
	"./product/components/topBanner.vue": [
		"d289",
		"chunk-433b92c9"
	],
	"./product/digitalSystem.vue": [
		"a3b7",
		"chunk-443111da",
		"chunk-73a4595c",
		"chunk-079e323c",
		"chunk-2197ed40"
	],
	"./product/integration.vue": [
		"86a9",
		"chunk-443111da",
		"chunk-73a4595c",
		"chunk-079e323c",
		"chunk-9cda94fa"
	],
	"./product/intelligentService.vue": [
		"95f5",
		"chunk-443111da",
		"chunk-73a4595c",
		"chunk-079e323c",
		"chunk-22f7e090"
	],
	"./product/onlineAndOfflineIntegration.vue": [
		"bc57",
		"chunk-443111da",
		"chunk-73a4595c",
		"chunk-079e323c",
		"chunk-052a8188"
	],
	"./product/onlineErp.vue": [
		"fd6e",
		"chunk-443111da",
		"chunk-73a4595c",
		"chunk-079e323c",
		"chunk-c45bdd92"
	],
	"./product/retailMall.vue": [
		"a9fc",
		"chunk-443111da",
		"chunk-73a4595c",
		"chunk-079e323c",
		"chunk-0dbdfd9a"
	],
	"./product/robot/lm200.vue": [
		"1e82",
		"chunk-443111da",
		"chunk-73a4595c",
		"chunk-41459596"
	],
	"./product/robot/lm201.vue": [
		"db41",
		"chunk-443111da",
		"chunk-73a4595c",
		"chunk-085dd4c0"
	],
	"./product/robot/lm202.vue": [
		"593f",
		"chunk-443111da",
		"chunk-73a4595c",
		"chunk-05d915df"
	],
	"./product/robot/lm203.vue": [
		"8099f",
		"chunk-443111da",
		"chunk-73a4595c",
		"chunk-f91605a2"
	],
	"./product/robot/lm211.vue": [
		"3c1b",
		"chunk-443111da",
		"chunk-73a4595c",
		"chunk-ef476e6e"
	],
	"./product/scrmProduct.vue": [
		"0382",
		"chunk-443111da",
		"chunk-73a4595c",
		"chunk-ef5da71e"
	],
	"./qcSuper/QianchengContent.vue": [
		"e922",
		"chunk-6379c26a",
		"chunk-6c137696"
	],
	"./qcSuper/qcSuper.vue": [
		"faf4",
		"chunk-443111da",
		"chunk-73a4595c",
		"chunk-6379c26a",
		"chunk-61b43484"
	],
	"./qccloud/b2bChannel.vue": [
		"e3ad",
		"chunk-443111da",
		"chunk-73a4595c",
		"chunk-02aaeee5",
		"chunk-4cdeafcd"
	],
	"./qccloud/digit.vue": [
		"e036",
		"chunk-443111da",
		"chunk-73a4595c",
		"chunk-02aaeee5",
		"chunk-366e3c82"
	],
	"./qccloud/digitalSystem.vue": [
		"e563",
		"chunk-443111da",
		"chunk-73a4595c",
		"chunk-02aaeee5",
		"chunk-144cb761"
	],
	"./qccloud/live.vue": [
		"e6fe",
		"chunk-443111da",
		"chunk-73a4595c",
		"chunk-02aaeee5",
		"chunk-5d5abd33"
	],
	"./qccloud/marketing.vue": [
		"0389",
		"chunk-443111da",
		"chunk-73a4595c",
		"chunk-02aaeee5",
		"chunk-2b81cb0b"
	],
	"./qccloud/onlineAndOfflineIntegration.vue": [
		"8c91",
		"chunk-443111da",
		"chunk-73a4595c",
		"chunk-02aaeee5",
		"chunk-1755e9f8"
	],
	"./qccloud/onlineErp.vue": [
		"d893",
		"chunk-443111da",
		"chunk-73a4595c",
		"chunk-02aaeee5",
		"chunk-7cf7ee74"
	],
	"./qccloud/retailMall.vue": [
		"5c71",
		"chunk-443111da",
		"chunk-73a4595c",
		"chunk-02aaeee5",
		"chunk-e9c60b26"
	],
	"./qccloud/s2b2c.vue": [
		"0b05",
		"chunk-443111da",
		"chunk-73a4595c",
		"chunk-02aaeee5",
		"chunk-7ced8e0a"
	],
	"./qccloud/scrmProduct.vue": [
		"1820",
		"chunk-443111da",
		"chunk-73a4595c",
		"chunk-02aaeee5",
		"chunk-2bfb8fd8"
	],
	"./qccloud/shopkeeper.vue": [
		"a01a",
		"chunk-443111da",
		"chunk-73a4595c",
		"chunk-02aaeee5",
		"chunk-04cd594c"
	],
	"./qccloud/tool.vue": [
		"79e3",
		"chunk-443111da",
		"chunk-73a4595c",
		"chunk-02aaeee5",
		"chunk-14096dd0"
	],
	"./solution/QcDownload.vue": [
		"9d4c",
		"chunk-22f3313c",
		"chunk-0d0bb14a"
	],
	"./solution/components/banner.vue": [
		"f53d",
		"chunk-443111da",
		"chunk-73a4595c",
		"chunk-2450dcd4"
	],
	"./solution/components/floor2.vue": [
		"0028",
		"chunk-1d8ecb8d"
	],
	"./solution/index.vue": [
		"60e0",
		"chunk-443111da",
		"chunk-73a4595c",
		"chunk-1938b1db",
		"chunk-12171154"
	],
	"./solution/live.vue": [
		"b92d",
		"chunk-443111da",
		"chunk-73a4595c",
		"chunk-1938b1db",
		"chunk-50f91793"
	],
	"./solution/retail.vue": [
		"6bef",
		"chunk-443111da",
		"chunk-73a4595c",
		"chunk-1938b1db",
		"chunk-e180930a"
	],
	"./solution/shopping.vue": [
		"83a8",
		"chunk-443111da",
		"chunk-73a4595c",
		"chunk-17ddc71b"
	],
	"./solution/store.vue": [
		"b8e9",
		"chunk-443111da",
		"chunk-73a4595c",
		"chunk-1938b1db",
		"chunk-e62af1ee"
	],
	"./solutions/robot/retail.vue": [
		"8498",
		"chunk-443111da",
		"chunk-73a4595c",
		"chunk-7d81a2e0"
	],
	"./solutions/robot/security.vue": [
		"b7b8",
		"chunk-443111da",
		"chunk-73a4595c",
		"chunk-6a67248e"
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "a2f9";
module.exports = webpackAsyncContext;